import type { HeaderIconType } from 'mini-header';
import NavigationRegular from 'mini-fluent-svg-icons/lib/icons/NavigationRegular';

export const getHamburgerHeaderIcon = (iconReference, onClick, arialLabel): HeaderIconType => ({
    icon: NavigationRegular,
    iconRef: iconReference,
    onClick: onClick,
    ariaLabel: arialLabel,
    ariaHasPopup: true,
});
